import styled from 'styled-components';
import React, { FC, useEffect, useState } from 'react';
import Variables from '../../../design-system/variables';
import { QuestionOption } from '../../../common/model/dto/survey/question-option';
import Checkbox from '@mui/material/Checkbox';

export interface OvCheckboxesSurveyQuestionProps {
  onChange?: (value: string[]) => void;
  value?: string[];
  question_options?: QuestionOption[];
}

const OvCheckboxesSurveyQuestion: FC<OvCheckboxesSurveyQuestionProps> = ({
  onChange,
  value,
  question_options,
}) => {
  const [selectedValues, setSelectedValues] = useState<string[] | undefined>(
    []
  );

  useEffect(() => {
    if (value !== selectedValues && value) {
      setSelectedValues(value);
    }
  }, [value, selectedValues]);

  const handleValueChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    const checked = event.target.checked;

    setSelectedValues((values) => {
      if (checked) {
        values?.push(value);
      } else {
        values = values?.filter((v) => v !== value);
      }

      if (onChange && values) {
        onChange(values);
      }
      return values;
    });
  };

  return (
    <Container>
      {question_options?.map(({ label, id }) => (
        <FormLabel key={id}>
          <FormLabelText>{label}</FormLabelText>

          <Checkbox
            checked={!!selectedValues?.find((value) => value === label)}
            onChange={(event) => handleValueChange(event, label)}
          />
        </FormLabel>
      ))}
    </Container>
  );
};

export default OvCheckboxesSurveyQuestion;

const Container = styled.div`
  display: flex;
  justify-content: center;
  max-width: 38.75rem;
  width: 100%;
  align-items: center;
  gap: 0.5rem;
`;

const FormLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: ${Variables.fontSizes.MEDIUM};
  gap: 0.5rem;
`;

const FormLabelText = styled.span`
  white-space: nowrap;
`;
